export default __webpack_public_path__ + "static/media/img4.2.e822efc0.jpg";